@if (_size !== 'small') {
  <div
    class="elem-count"
    [ngClass]="{
      'elem-count-light': _isLightTheme && _type === null,
      'elem-count-dark': _isDarkTheme && _type === null,
      'elem-count-paper': _isPaperTheme && _type === null,
      'elem-count-bw-light': (_isLightTheme || _isPaperTheme) && _type === 'black_and_white',
      'elem-count-bw-dark': _isDarkTheme && _type === 'black_and_white',
    }"
  >
    <span class="material-icons">
      {{ _icon }}
    </span>
    <div>{{ _count }}</div>
  </div>
} @else {
  <div
    class="elem-count-sm"
    [ngClass]="{
      'elem-count-light': _isLightTheme,
      'elem-count-dark': _isDarkTheme,
      'elem-count-paper': _isPaperTheme,
    }"
  >
    <span class="material-icons icon-small">
      {{ _icon }}
    </span>
    <div>{{ _count }}</div>
  </div>
}
